import { render, staticRenderFns } from "./CursoVersionGrabadoVivo.vue?vue&type=template&id=f5ab641e&"
import script from "./CursoVersionGrabadoVivo.vue?vue&type=script&lang=js&"
export * from "./CursoVersionGrabadoVivo.vue?vue&type=script&lang=js&"
import style0 from "./CursoVersionGrabadoVivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports